import { useState } from 'react'
import { Card, Nav, Tab } from 'react-bootstrap'
import { ProductsPage } from './ProductsPage'
import { OrganizationsPage } from './OrganizationsPage'
import { CategoriesPage } from './CategoriesPage'
import { PrioritiesPage } from './PrioritiesPage'
import { SLAPoliciesPage } from './SLAPoliciesPage'
import { APIKeysPage } from './APIKeysPage'

export const AdminPage = () => {
  const [activeTab, setActiveTab] = useState('organizations')

  return (
    <div className="settings-page">
      {/* Header */}
      <div className="mb-4">
        <h1 className="mb-1">
          <i className="fas fa-cogs me-2 text-primary"></i>
          Settings
        </h1>
        <p className="text-muted mb-0">Manage system configuration and settings</p>
      </div>

      <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'organizations')}>
        <Card className="border-0 shadow-sm">
          <Card.Header className="bg-white border-bottom">
            <Nav variant="tabs" className="border-0">
              <Nav.Item>
                <Nav.Link eventKey="organizations" className="d-flex align-items-center">
                  <i className="fas fa-building me-2"></i>
                  Organizations
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="products" className="d-flex align-items-center">
                  <i className="fas fa-box me-2"></i>
                  Products
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="categories" className="d-flex align-items-center">
                  <i className="fas fa-folder me-2"></i>
                  Categories
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="priorities" className="d-flex align-items-center">
                  <i className="fas fa-flag me-2"></i>
                  Priorities
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="sla" className="d-flex align-items-center">
                  <i className="fas fa-stopwatch me-2"></i>
                  SLA Policies
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="apiKeys" className="d-flex align-items-center">
                  <i className="fas fa-key me-2"></i>
                  API Keys
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body className="p-4">
            <Tab.Content>
              {/* Organizations Tab */}
              <Tab.Pane eventKey="organizations">
                <OrganizationsPage />
              </Tab.Pane>

              {/* Products Tab */}
              <Tab.Pane eventKey="products">
                <ProductsPage />
              </Tab.Pane>

              {/* Categories Tab */}
              <Tab.Pane eventKey="categories">
                <CategoriesPage />
              </Tab.Pane>

              {/* Priorities Tab */}
              <Tab.Pane eventKey="priorities">
                <PrioritiesPage />
              </Tab.Pane>

              {/* SLA Policies Tab */}
              <Tab.Pane eventKey="sla">
                <SLAPoliciesPage />
              </Tab.Pane>

              {/* API Keys Tab */}
              <Tab.Pane eventKey="apiKeys">
                <APIKeysPage />
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Card>
      </Tab.Container>
    </div>
  )
}
